import React from "react";
import { formatCurrency, formatPercentage } from "../../../../utils/formatters";
import { motion, AnimatePresence } from "framer-motion";

const DebtsForm = ({ data, onChange }) => {
  const handleDebtChange = (index, field, value) => {
    const newDebts = [...data];
    newDebts[index] = {
      ...newDebts[index],
      [field]: value,
    };
    onChange(newDebts);
  };

  const handleRemoveDebt = (index) => {
    const newDebts = [...data];
    newDebts.splice(index, 1);
    onChange(newDebts);
  };

  const renderDebtFields = (debt, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="border p-4 rounded mb-4 bg-surface-default dark:bg-surface-default shadow-sm"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Type
          </label>
          <select
            value={debt.type || ""}
            onChange={(e) => handleDebtChange(index, "type", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          >
            <option value="">Select Type</option>
            <option value="mortgage">Mortgage</option>
            <option value="car_loan">Car Loan</option>
            <option value="personal_loan">Personal Loan</option>
            <option value="credit_card">Credit Card</option>
            <option value="student_loan">Student Loan</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Balance
          </label>
          <div className="relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 dark:text-gray-500 sm:text-sm">$</span>
            </div>
            <input
              type="number"
              value={debt.balance || ""}
              onChange={(e) =>
                handleDebtChange(index, "balance", e.target.value)
              }
              className="mt-1 block w-full pl-7 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="0.00"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Minimum Payment
          </label>
          <div className="relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 dark:text-gray-500 sm:text-sm">$</span>
            </div>
            <input
              type="number"
              value={debt.minimumPayment || ""}
              onChange={(e) =>
                handleDebtChange(index, "minimumPayment", e.target.value)
              }
              className="mt-1 block w-full pl-7 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="0.00"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Actual Payment
          </label>
          <div className="relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 dark:text-gray-500 sm:text-sm">$</span>
            </div>
            <input
              type="number"
              value={debt.actualPayment || ""}
              onChange={(e) =>
                handleDebtChange(index, "actualPayment", e.target.value)
              }
              className="mt-1 block w-full pl-7 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="0.00"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Interest Rate (%)
          </label>
          <input
            type="number"
            value={debt.interestRate || ""}
            onChange={(e) =>
              handleDebtChange(index, "interestRate", e.target.value)
            }
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder="0.00"
            step="0.01"
          />
        </div>
        <div className="flex items-center justify-end lg:col-span-4">
          <button
            type="button"
            onClick={() => handleRemoveDebt(index)}
            className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Remove Debt
          </button>
        </div>
      </div>
    </motion.div>
  );

  return (
    <div className="space-y-6 bg-gray-50 p-6 rounded-lg">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Liabilities</h3>
        <button
          type="button"
          onClick={() => onChange([...data, {}])}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Add Liability
        </button>
      </div>
      <AnimatePresence>
        {data.map((debt, index) => renderDebtFields(debt, index))}
      </AnimatePresence>
    </div>
  );
};

export default DebtsForm;
